import { Chance } from 'chance'

export const MOCK_API = new Chance()
